import { Action } from '@ngrx/store';
import { PensionSavings } from 'src/app/model/ngrx/pension-savings.model';

export const ADD_PENSION_SAVINGS = '[PENSION_SAVINGS] Add';
export const REMOVE_PENSION_SAVINGS = '[PENSION_SAVINGS] Remove';

// AddPersonalDetails
export class AddPensionSavings implements Action {
    readonly type = ADD_PENSION_SAVINGS;

    constructor(public payload: PensionSavings) { }
}
// RemovePersonalDetails
export class RemovePensionSavings implements Action {
    readonly type = REMOVE_PENSION_SAVINGS;

    constructor(public payload: number) { }
}

export type YourPensionSavingsAction = AddPensionSavings | RemovePensionSavings;
